<template>
  <div
    v-if="catalogData"
    :class="{
      'product-detail-head-fi': true,
      'product-detail-head-fite-fi': true,
      'product-detail-head-fi--no-margin-bottom': noMarginBottom,
    }"
  >
    <grid-container-fi>
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-end-7">
        <catalog-slider-fi
          :catalog-data="catalogData"
          :item-name="productName"
        />
      </div>
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-7 md:fi-col-end-13">
        <div
          v-if="isNew"
          class="product-detail-head-fi__badge"
        >
          <span class="product-detail-head-fi__badge__text"
            >{{ $dict.get('online-Shop.Product.New-Product-Badge') }}
          </span>
        </div>

        <headline-fi
          v-if="articleNumber"
          class="product-detail-head-fi__art-nr"
          tag="div"
          color="grey-dark"
          :size="18"
          :html-content="articleNumber"
        />
        <headline-fi
          v-if="marketingClaim"
          class="product-detail-head-fi__marketing-claim"
          tag="h2"
          color="brand"
          :size="24"
          :html-content="marketingClaim"
        />
        <headline-fi
          v-if="productName"
          class="product-detail-head-fi__name"
          tag="h1"
          :size="48"
          :html-content="productName"
        />

        <div class="product-detail-head-fi__links">
          <link-fi
            v-if="categorySlug"
            class="product-detail-head-fi__link"
            :href="categorySlug"
            :size="18"
          >
            {{ $dict.get('product-Family.Anchor-Link-Text') }}
          </link-fi>

          <link-fi
            v-if="eLearningLink"
            class="product-detail-head-fi__link"
            :href="eLearningLink.Url"
            :external="Boolean(eLearningLink.Url)"
            :size="18"
          >
            {{ $dict.get('online-Shop.Product.E-Learning-Link') }}
          </link-fi>

          <link-fi
            v-if="
              fields.customLink?.value &&
              (fields.customLink.value.href || fields.customLink.value.url)
            "
            class="product-detail-head-fi__link"
            :href="
              fields.customLink.value.href
                ? fields.customLink.value.href
                : fields.customLink.value.url
            "
            :external="Boolean(fields.customLink.value.url)"
            :target="fields.customLink.value.target"
            :size="18"
          >
            {{ fields.customLink.value.text }}
          </link-fi>

          <link-fi
            v-if="mediaDownloadLink && fields.mediaDownloadLabel?.value"
            class="product-detail-head-fi__link"
            href="#"
            rel="nofollow"
            :size="18"
            @click.stop.prevent="openMediaDownloadDialog"
          >
            {{ fields.mediaDownloadLabel.value }}
          </link-fi>
        </div>
        <grid-columns-fi :columns="6">
          <div class="fi-col-span-6 lg:fi-col-span-5">
            <div class="product-detail-head-fi__features">
              <text-expander-fi
                v-if="features"
                :content="{ value: features }"
                :max-height="400"
                :expand-text="$dict.get('global-Labels.Expander.Expand')"
                :reduce-text="$dict.get('global-Labels.Expander.Reduce')"
              />
            </div>

            <div class="product-detail-head-fi__attributes">
              <product-attributes-fi :attributes="attributes" />
            </div>

            <template v-if="shopifyEnabled">
              <loading-indicator-wrapper
                :loading="!isMounted"
                variant="spinnerLocal"
                class="product-detail-head-fi__shopify"
              >
                <div id="product-component-1743423183593" />
              </loading-indicator-wrapper>

              <ul class="product-detail-head-fi__shopify__list">
                <li v-if="fields.shippingCosts?.value">{{ fields.shippingCosts.value }}</li>
                <li v-if="fields.freeOfCharge?.value">{{ fields.freeOfCharge.value }}</li>
                <li v-if="fields.deliveryTime?.value">{{ fields.deliveryTime.value }}</li>
                <li v-if="fields.rightOfWithdrawal?.value">
                  {{ fields.rightOfWithdrawal.value }}
                </li>
              </ul>
            </template>

            <template v-else>
              <template v-if="productPrice">
                <div
                  class="product-detail-head-fi__price"
                  data-test="product-price"
                >
                  {{ $dict.get('online-Shop.Product.UVP-Price-Prefix') }} {{ productPrice }}
                </div>

                <div class="product-detail-head-fi__price-vat">
                  {{ $dict.get('online-Shop.Product.Vat-included') }}
                </div>
              </template>

              <div
                v-if="retailers || shopUrl"
                class="product-detail-head-fi__retail-connect-cart-actions product-detail-head-fi__retail-connect-cart-actions--md"
              >
                <!-- PLACEHOLDER FOR FUTURE ADD TO FAVOURITE LIST -->
                <div />

                <button-fi
                  v-if="retailers.length || (!retailers.length && !shopUrl)"
                  class="button-fi__primary--large button__to-retailer"
                  type="button"
                  data-test="open-retailers"
                  :disabled="!retailers.length"
                  @click.stop.prevent="openProductRetailerDialog"
                >
                  {{ $dict.get('online-Shop.Product.Retail-Connect.Show-Retailers') }}
                </button-fi>

                <button-fi
                  v-else-if="shopUrl"
                  :href="shopUrl"
                  target="_blank"
                  rel="noopener"
                  class="button-fi__primary--large"
                  natural-events
                  @natural-click="onShopUrlClicked"
                >
                  {{ $dict.get('online-Shop.Product.Retail-Connect.Buy-Product') }}
                </button-fi>
              </div>
            </template>
          </div>
        </grid-columns-fi>
      </div>

      <media-download-dialog-fi
        ref="mediaDownloadDialog"
        :media-download-link="mediaDownloadLink"
        :fields="fields"
      />

      <product-retailer-dialog-fite-fi
        ref="productRetailerDialog"
        :retailers="retailers"
      />
    </grid-container-fi>

    <span
      v-intersect="onIntersect"
      class="sticky-actions-intersector"
    />
    <div
      v-if="!shopifyEnabled && (retailers || shopUrl)"
      :class="{
        'product-detail-head-fi__actions-mobile': true,
        'product-detail-head-fi__actions-mobile--sticky': stickyEnabled,
      }"
    >
      <div class="product-detail-head-fi__retail-connect-cart-actions">
        <!-- PLACEHODER FOR FUTURE ADD TO FAVOURITE LIST -->
        <div v-if="isSM" />

        <button-fi
          v-if="retailers.length || (!retailers.length && !shopUrl)"
          type="button"
          class="button-fi__primary--large button__to-retailer"
          :disabled="!retailers.length"
          @click.stop.prevent="openProductRetailerDialog"
        >
          {{ $dict.get('online-Shop.Product.Retail-Connect.Show-Retailers') }}
        </button-fi>

        <button-fi
          v-else-if="shopUrl"
          :href="shopUrl"
          target="_blank"
          rel="noopener"
          class="button-fi__primary--large button__to-retailer"
          natural-events
          @natural-click="onShopUrlClicked"
        >
          {{ $dict.get('online-Shop.Product.Retail-Connect.Buy-Product') }}
        </button-fi>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ButtonFi, HeadlineFi, LinkFi, LoadingIndicatorWrapper } from 'atoms';
import { computed, onMounted, ref, useTemplateRef, watch } from 'vue';

import CatalogSliderFi from '@/components/catalog-slider-fi/CatalogSliderFi.vue';
import GridColumnsFi from '@/components/grid-fi/GridColumnsFi.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import MediaDownloadDialogFi from '@/components/product-detail/media-download-dialog-fi/MediaDownloadDialogFi.vue';
import ProductAttributesFi from '@/components/product-detail/product-detail-head-fi/product-attributes-fi/ProductAttributesFi.vue';
import ProductRetailerDialogFiteFi from '@/components/product-detail/product-retailer-dialog-fi/ProductRetailerDialogFiteFi.vue';
import TextExpanderFi from '@/components/text-expander-fi/TextExpanderFi.vue';
import { useBreakpoints } from '@/composables/breakpoint';
import { useCatalogTextList } from '@/composables/catalogTextList';
import { useFields } from '@/composables/fields';
import { useDict, useFischer } from '@/composables/fischerPlugin';
import { usePriceCurrency } from '@/composables/priceCurrency';
import theme from '@/plugins/tailwind-theme';

defineOptions({ name: 'ProductDetailHeadFiteFi' });

const props = withDefaults(
  defineProps<{
    catalogData?: object | null;
    mediaDownloadLink?: string | null;
    noMarginBottom?: boolean;
  }>(),
  {
    catalogData: null,
    mediaDownloadLink: null,
    noMarginBottom: false,
  },
);

const fields = useFields('ProductDetailPageFiteFiFields');
const fischer = useFischer();
const dict = useDict();
const { isSM } = useBreakpoints();
const { formatPrice } = usePriceCurrency();

const mediaDownloadDialog = useTemplateRef('mediaDownloadDialog');
const productRetailerDialog = useTemplateRef('productRetailerDialog');

const stickyEnabled = ref(false);
const isNew = ref(false); // SMELL: this feature seems to got lost
const isMounted = ref(false);
const shopifyLoaded = ref(false);

const { textListValue } = useCatalogTextList();

const articleNumber = computed(() => {
  const artNr = (props.catalogData as any)?.ProductId;
  return `${dict.get('product-List.Table.Article-Number')} ${artNr}`;
});

const marketingClaim = computed(() =>
  textListValue((props.catalogData as any)?.TextList, 'DOKBSTMARKCLAIM'),
);

const categorySlug = computed(
  () =>
    (props.catalogData as any)?.categoryData?.CategoryRole === 'FAMILY_PAGE' &&
    (props.catalogData as any)?.categoryData?.Slug &&
    `${fischer.pages.products().url}${(props.catalogData as any).categoryData.Slug}#productList`,
);

const productName = computed(() => textListValue((props.catalogData as any)?.TextList, 'ECOMLANG'));

const productPrice = computed(() => {
  const data = props.catalogData as any;
  if (data?.ProductPrice && data.ProductPriceCurrency) {
    return formatPrice(data.ProductPrice, data.ProductPriceCurrency);
  }
  return null;
});

const features = computed(() =>
  textListValue((props.catalogData as any)?.TextList, 'POCTOPFEATURESGEN'),
);

const attributes = computed(() => (props.catalogData as any)?.Attributes);

const shopUrl = computed(() => {
  const shopLink = (props.catalogData as any)?.Links?.find((el: any) => el.Type === 'SHOP');
  return shopLink?.Url || null;
});

const eLearningLink = computed(() => {
  if (!props.catalogData || !(props.catalogData as any).Links) {
    return null;
  }
  return (props.catalogData as any)?.Links?.find((l: any) => l.Type === 'ELEARNING');
});

const retailers = computed(() => (props.catalogData as any)?.RetailerLinks);

const shopifyId = computed(
  () => (props.catalogData as any)?.ExternalIds?.find((el: any) => el.Key === 'ShopifyID')?.Value,
);

const shopifyEnabled = computed(() =>
  Boolean(fields.enableShopify?.value && fields.storefrontAccessToken?.value && shopifyId.value),
);

const openMediaDownloadDialog = () => {
  (mediaDownloadDialog.value as any).show();
};

const openProductRetailerDialog = () => {
  (productRetailerDialog.value as any).show();
};

const onIntersect = (observer: any) => {
  stickyEnabled.value = !observer[0].isIntersecting && observer[0].boundingClientRect.top > 0;
};

const onShopUrlClicked = () => {
  if (!IS_SSR) {
    const productNameVal = `${(props.catalogData as any).ProductId} - ${productName.value}`;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'RCBuyProduct',
      productName: productNameVal,
    });
  }
};

const shopifyBuyInit = () => {
  const id = shopifyId.value;

  const client = (window as any).ShopifyBuy.buildClient({
    domain: 'shop.fischertechnik.de',
    storefrontAccessToken: fields.storefrontAccessToken?.value,
  });

  (window as any).ShopifyBuy.UI.onReady(client).then((ui: any) => {
    ui.createComponent('product', {
      id,
      node: document.getElementById('product-component-1743423183593'),
      moneyFormat: '%7B%7Bamount_with_comma_separator%7D%7D%20%E2%82%AC%0A',
      options: {
        product: {
          iframe: false,
          buttonDestination: 'cart',
          templates: {
            description: `<div class="shopify-buy__hint">${dict.get('online-Shop.Product.Vat-included')}</div>`,
          },
          text: {
            button: fields.addToCartButton?.value,
            outOfStock: fields.outOfStockButton?.value,
            unavailable: fields.unavailableButton?.value,
          },
          contents: {
            img: false,
            title: false,
            description: true,
          },
          classes: {
            button: 'button-fi__primary--large',
          },
        },
        toggle: {
          styles: {
            toggle: {
              color: (theme as any).fite?.white,
              'background-color': (theme as any).fite?.brand,
              ':hover': {
                'background-color': (theme as any).fite?.grey,
              },
              ':focus': {
                'background-color': (theme as any).fite?.grey,
              },
            },
          },
        },
        cart: {
          buttonDestination: 'checkout',
          text: {
            title: fields.cartTitle?.value,
            empty: fields.cartEmpty?.value,
            button: fields.cartBuyButton?.value,
            total: fields.cartTotal?.value,
            notice: fields.cartNotice?.value,
            noteDescription: fields.cartNoteDescription?.value,
          },
          styles: {
            button: {
              color: (theme as any).fite?.white,
              'background-color': (theme as any).fite?.brand,
              ':hover': {
                'background-color': (theme as any).fite?.grey,
              },
              ':focus': {
                'background-color': (theme as any).fite?.grey,
              },
            },
          },
        },
      },
    });
  });
};

const loadScript = () => {
  const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
  const script = document.createElement('script');
  script.async = true;
  script.src = scriptURL;
  window.document.body.appendChild(script);
  script.onload = shopifyBuyInit;
};

const loadShopify = () => {
  if (IS_SSR || shopifyLoaded.value || !shopifyEnabled.value) {
    return;
  }

  if ((window as any).ShopifyBuy) {
    if ((window as any).ShopifyBuy.UI) {
      shopifyBuyInit();
    } else {
      loadScript();
    }
  } else {
    loadScript();
  }

  shopifyLoaded.value = true;
};

watch(
  () => props.catalogData,
  (newValue) => {
    if (newValue) {
      loadShopify();
    }
  },
  { immediate: true },
);

onMounted(() => {
  loadShopify();
  isMounted.value = true;
});
</script>

<style scoped src="./product-detail-head-fi_product-detail-head-fite-fi" />

<style src="./product-detail-head-fi_product-detail-head-fite-fi-unscoped" />
